/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import type { PostLoginResponseBase } from '../../api/account';

import type { AuthScreen } from '../authModal.slice';

export interface AuthModalContextValue {
    screen: AuthScreen;
    setScreen: (screen: AuthScreen) => void;
    closeModal: (options?: { preventRedirect?: boolean }) => void;
    cleanUpParamsAndStorage: () => void;
    storeUserData: (userData: PostLoginResponseBase) => void;
    isCloseConfirmationOpen: boolean;
    setIsCloseConfirmationOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AuthModalContext = React.createContext<AuthModalContextValue | undefined>(
    undefined
);

export function useAuthModalsContext(): AuthModalContextValue {
    const ctx = React.useContext(AuthModalContext);
    if (!ctx) {
        throw new Error(
            'useAuthModalsContext must be used within an AuthModalContext.Provider'
        );
    }
    return ctx;
}
